import React from "react";
import { IconRefresh } from "@tabler/icons-react";
import { Alert, AlertDescription, AlertTitle, Button } from "@lemonadetraining/web-ui";

import { useVersionCheck } from "../hooks/useVersionCheck";

const VersionBanner = () => {
  const { updateAvailable, dismiss } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <Alert role="status" className="mb-4" data-testid="version-banner">
      <IconRefresh aria-hidden="true" />
      <AlertTitle>A new version of the dashboard is available.</AlertTitle>
      {/* col-start-2: the Alert's icon row-span does not apply, so pin the column. */}
      <AlertDescription className="col-start-2 flex flex-col items-start gap-2">
        <span>Reload to get it.</span>
        <div className="flex flex-wrap items-center gap-2">
          <Button size="sm" className="min-h-11" onClick={() => window.location.reload()}>
            Reload
          </Button>
          <Button
            size="sm"
            variant="ghost"
            className="min-h-11"
            onClick={dismiss}
            aria-label="Dismiss"
          >
            Dismiss
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
};

export default VersionBanner;
